import React from "react";
import PropTypes from 'prop-types';

export default function StoryRequestListItem({ story, editStoryRequest }) {
  const { _id, name, referenceId, merchant } = story;
  return (
    <div className="mb-4">
      <div className="items-list-item">
        <div className="list-item-1 list-item-product">
          <div className="product-details">
            <div>
              <span className="name">{merchant.username}</span>
            </div>
          </div>
        </div>
        <div className="list-item-2">
          <div className="product-details">
            <div>
              <span className="name">{name}</span>
            </div>
          </div>
        </div>
        <div className="list-item-3">{referenceId}</div>

        <div className="list-item-4">{merchant.phone}</div>
        <div className="list-item-5">{merchant.email}</div>
        <div className="list-item-6 list-item-actions">
          <span
            className="ar-icon s7-edit"
            onClick={() => {
              editStoryRequest(_id);
            }}
          />
        </div>
      </div>
    </div>
  );
}

StoryRequestListItem.propTypes = {
  story: PropTypes.object.isRequired,
  editStoryRequest: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Story/StoryRequestListItem.js